import styled from 'styled-components';
import { StyledSelect } from '../../../shared/FormStyles';

const IntervalSelect = ({ options, setInterval, interval }) => {
  const DropdownIndicator = ({ ...props }) => {
    const icon = props.selectProps.menuIsOpen
      ? 'fa-chevron-up'
      : 'fa-chevron-down';

    return <i className={`fa-solid ${icon}`}></i>;
  };

  return (
    <SelectWrapper>
      <Select
        classNamePrefix="react-select"
        styles={{
          dropdownIndicator: (base, state) => ({
            transform: state.selectProps.menuIsOpen ? 'rotate(180deg)' : null,
          }),
        }}
        components={{
          IndicatorSeparator: () => null,
          DropdownIndicator: DropdownIndicator,
        }}
        onChange={({ value }) => setInterval(value)}
        isSearchable={false}
        options={options}
        value={options.find(option => option.value === interval)}
      />
    </SelectWrapper>
  );
};

export default IntervalSelect;

const SelectWrapper = styled.div`
  margin: 0 0 0 16px;
  width: 112px;
  height: 40px;
`;

const Select = styled(StyledSelect)`
  .react-select__control {
    height: 38px;
  }

  .react-select__value-container {
    padding: 0;
  }
`;
